import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntDesignOutlinedSvg from "@ant-design/icons-svg/es/asn/AntDesignOutlined";
import AntdIcon from "../components/AntdIcon";
var AntDesignOutlined = function AntDesignOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AntDesignOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AntDesignOutlined.displayName = 'AntDesignOutlined';
}
export default /*#__PURE__*/React.forwardRef(AntDesignOutlined);